import {Directive, ElementRef, Renderer2, AfterViewInit, HostListener} from '@angular/core';

import {filter} from "rxjs";
import {HeroStyleService} from "../../service/hero-style.service";

@Directive({
  selector: 'input[type=text].hero-input-adjust',
  standalone: true,
})
export class HeroInputAdjustDirective implements AfterViewInit {

  private sizer: HTMLElement;
  private styleProperties = [
    'font-family',
    'font-size',
    'font-weight',
    'font-style',
    'letter-spacing',
    'line-height',
    'text-transform',
    'text-decoration',
    'padding-left',
    'padding-right',
    'border-left-width',
    'border-right-width',
    'box-sizing',
    'word-spacing',
    'text-indent'
  ];

  constructor(
    private el: ElementRef<HTMLInputElement>,
    private renderer: Renderer2,
    private styleServ: HeroStyleService
  ) {
    // Create a hidden sizer span
    this.sizer = this.renderer.createElement('span');
    this.renderer.addClass(this.sizer, 'sizer');
    this.renderer.setStyle(this.sizer, 'position', 'absolute');
    this.renderer.setStyle(this.sizer, 'visibility', 'hidden');
    this.renderer.setStyle(this.sizer, 'white-space', 'nowrap');
    this.renderer.setStyle(this.sizer, 'font-family', 'inherit');
    this.renderer.setStyle(this.sizer, 'font-size', 'inherit');
    this.renderer.setStyle(this.sizer, 'padding', '5px');
    this.renderer.appendChild(this.el.nativeElement.parentNode, this.sizer);
  }

  ngAfterViewInit(): void {
    // Copy computed styles from input to sizer
    this.styleServ.styleLoaded$
      .pipe(filter(v => !!v))
      .subscribe((v) => {
        const styles = window.getComputedStyle(this.el.nativeElement);
        this.styleProperties.forEach(prop => this.renderer.setStyle(this.sizer, prop, styles.getPropertyValue(prop)));
        this.adjustWidth();
      });
  }

  @HostListener('input')
  onInput(): void {
    this.adjustWidth();
  }

  private adjustWidth(): void {
    // Use input value if present, otherwise fallback to placeholder
    const content = this.el.nativeElement.value || this.el.nativeElement.placeholder || '';
    this.renderer.setProperty(this.sizer, 'textContent', content);
    // Set input width to sizer's width, with a minimum of 20px
    const width = this.sizer.offsetWidth;
    this.renderer.setStyle(this.el.nativeElement, 'width', `${Math.max(width, 20)}px`);
  }

}
